<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        small
        color="error"
        v-on="on"
      >
        <v-icon>
          mdi-window-close
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-text class="font-weight-bold">
        Are you sure you want to delete this record?
      </v-card-text>

      <v-card-text class="pt-0">
        <v-textarea
          v-model="remark"
          v-validate="'required|max:255'"
          counter
          :error-messages="errors.collect('remark')"
          data-vv-name="remark"      
          label="Remark"
          rows="3"
          fillable
          auto-grow
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          class="white--text"
          color="hrissecondary"          
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions> 
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      payrollTransactionDetail: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
        remark: null,
      }
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 
            this.progressing = true

            this.$api.payrollTransactionDetails().delete(this.payrollTransactionDetail.id, { remark: this.remark })
              .then(response => {
                if (response.status >= 200 && response.status < 300) {
                  this.$emit('deleted')
                  this.$snack({ message: response.data.status })

                  this.menu = false
                }
              })
              .catch(error => {
                if (error.response.status >= 400 && error.response.status < 500) {
                  this.$snack({ 
                    color: 'error',
                    message: error.response.data.status, 
                  })
                }
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
    },
  }
</script>
